export const environment = {
    development: true,
    apiUrl: 'https://gstn.org.in/GSTAT-STAFF-BO',//http://localhost:80/GSTAT-STAFF-BO  // https://gstn.org.in/GSTAT-STAFF-BO
    recaptcha: {
         siteKey: '6Lcjcr0ZAAAAAKgmOglmpc3ZZmbHNbQe8ah3cRDY', //production
        //siteKey:'6LfQ8UspAAAAACHV-_AWjYdjpOi2zckEHaWm50u7'  // localhost
      },
};
